// Définitions des 4 questionnaires AUPRÉA — data pure, pas de composant
// Chaque question a : id, texte, type ("opn" | "oui_non" | "gradue3" | "gradue3+nc" | "libre" | "date" | "select" | "annee" | "multiselect")
// gradue3 : 3 réponses ordonnées (favorable / intermédiaire / défavorable)

export const PARCOURS_CATALOG = [
  { code: "bilan_succession", titre: "Bilan Succession", cible: "Particulier",
    tarif: "Gratuit", intro: "15 questions · 3 piliers · réponse Oui / Partiellement / Non", couleur: "#1F7A6C" },
  { code: "bilan_dirigeants", titre: "Bilan Dirigeants", cible: "Professionnel",
    tarif: "Gratuit", intro: "14 questions · 5 sections · 3 réponses graduées", couleur: "#3C3489" },
  { code: "ouvrir_succession", titre: "Ouvrir une succession", cible: "Après un décès",
    tarif: "Diagnostic gratuit · Feuille de route 89 €", intro: "Le défunt · Héritiers · Patrimoine · Documents", couleur: "#B45309" },
  { code: "foncier_clair", titre: "Foncier Clair", cible: "Outre-mer · prescription acquisitive",
    tarif: "Verdict gratuit · Fiche 69 €", intro: "Bien · Possession · Titre & preuves", couleur: "#9A7B2E" },
];

// ═══════════════ A) BILAN SUCCESSION ══════════════════════════════════════════
const OPN = { type: "opn", options: [
  { value: "oui", label: "Oui", score: 2 },
  { value: "partiellement", label: "Partiellement", score: 1 },
  { value: "non", label: "Non", score: 0 },
]};

export const QUESTIONNAIRE_SUCCESSION = {
  code: "bilan_succession",
  sections: [
    { code: "pilier1", titre: "Pilier 1 — Organisation administrative", questions: [
      { id: "s1q1", texte: "Vos documents d'identité (actes de naissance, livrets) sont-ils à jour et accessibles ?", ...OPN },
      { id: "s1q2", texte: "Pouvez-vous localiser vos actes de propriété et titres de transport en moins de 5 minutes ?", ...OPN },
      { id: "s1q3", texte: "Avez-vous un inventaire écrit de vos biens mobiliers (bijoux, art, collections) ?", ...OPN },
      { id: "s1q4", texte: "Vos accès numériques (banques, impôts, mails) sont-ils sécurisés mais accessibles à vos proches ?", ...OPN },
      { id: "s1q5", texte: "Vos proches savent-ils exactement où trouver ces documents en cas d'urgence ?", ...OPN },
    ]},
    { code: "pilier2", titre: "Pilier 2 — Protection juridique & volontés", questions: [
      { id: "s2q1", texte: "Avez-vous rédigé un testament enregistré (notaire ou FCDDV) ?", ...OPN },
      { id: "s2q2", texte: "Avez-vous désigné une personne de confiance ou un exécuteur testamentaire ?", ...OPN },
      { id: "s2q3", texte: "Avez-vous anticipé une éventuelle dépendance via un mandat de protection future ?", ...OPN },
      { id: "s2q4", texte: "Connaissez-vous précisément les droits de vos héritiers selon votre situation (PACS, union libre, etc.) ?", ...OPN },
      { id: "s2q5", texte: "Avez-vous clairement exprimé vos volontés funéraires ?", ...OPN },
    ]},
    { code: "pilier3", titre: "Pilier 3 — Optimisation financière & fiscale", questions: [
      { id: "s3q1", texte: "Avez-vous actualisé la valeur de votre patrimoine global ces 12 derniers mois ?", ...OPN },
      { id: "s3q2", texte: "Les clauses bénéficiaires de vos assurances-vie ont-elles été révisées récemment ?", ...OPN },
      { id: "s3q3", texte: "Avez-vous mis en place des stratégies de transmission de votre vivant (donations, démembrement) ?", ...OPN },
      { id: "s3q4", texte: "Vos dettes et engagements financiers sont-ils listés et connus ?", ...OPN },
      { id: "s3q5", texte: "Avez-vous déjà consulté un expert (notaire, CGP) pour optimiser les droits de succession ?", ...OPN },
    ]},
  ],
  complementaires: {
    titre: "Questions complémentaires — visibles uniquement par vous",
    questions: [
      { id: "deces",     texte: "Un décès est-il survenu récemment dans la famille (succession non réglée) ?", type: "oui_non" },
      { id: "indivision",texte: "Possédez-vous un bien en indivision, un terrain sans titre ou issu d'une succession non réglée ?", type: "oui_non" },
      { id: "recompose", texte: "Famille recomposée ou héritiers dispersés (Hexagone, Outre-mer, étranger) ?", type: "oui_non" },
      { id: "dirigeant", texte: "Le client est-il chef d'entreprise ou associé ?", type: "oui_non" },
    ],
  },
};

// ═══════════════ B) BILAN DIRIGEANTS ═════════════════════════════════════════
const g3 = (a, b, c) => ({ type: "gradue3", options: [
  { value: "a", label: a, score: 2 }, { value: "b", label: b, score: 1 }, { value: "c", label: c, score: 0 },
]});

export const QUESTIONNAIRE_DIRIGEANTS = {
  code: "bilan_dirigeants",
  sections: [
    { code: "sect1", titre: "Section 1 — Gouvernance & dépendance", questions: [
      { id: "d1q1", texte: "Si vous étiez indisponible demain (maladie, accident) pendant plusieurs semaines, l'entreprise pourrait-elle continuer à fonctionner normalement ?",
        ...g3("Oui, tout est organisé et quelqu'un peut prendre le relais immédiatement", "Partiellement — certaines décisions m'attendraient", "Non, je suis le seul à détenir les informations clés") },
      { id: "d1q2", texte: "Avez-vous formalisé et communiqué qui prendrait les décisions à votre place en cas d'absence prolongée ?",
        ...g3("Oui, un mandat ou une délégation de pouvoir est en place", "J'y ai pensé, mais rien n'est signé", "Non, ce sujet n'a jamais été abordé") },
      { id: "d1q3", texte: "Un tiers de confiance connaît-il l'ensemble de vos accès stratégiques (banques, contrats, mots de passe) ?",
        ...g3("Oui, un document centralisé existe et est accessible", "Certains éléments sont partagés, pas tout", "Non, tout est dans ma tête") },
    ]},
    { code: "sect2", titre: "Section 2 — Structure & valorisation", questions: [
      { id: "d2q1", texte: "Avez-vous fait estimer la valeur de votre entreprise au cours des trois dernières années ?",
        ...g3("Oui, une valorisation récente existe", "Une estimation approximative, non formalisée", "Jamais") },
      { id: "d2q2", texte: "Vos statuts prévoient-ils clairement ce qui se passe en cas de décès ou d'incapacité d'un dirigeant ou associé ?",
        ...g3("Oui, une clause spécifique existe", "Les statuts en parlent vaguement", "Non, ou je ne sais pas") },
      { id: "d2q3", texte: "Si vous avez des associés, existe-t-il une clause de rachat des parts en cas de décès, financée (assurance croisée) ?",
        type: "gradue3+nc",
        options: [
          { value: "a", label: "Oui, formalisée et financée", score: 2 },
          { value: "b", label: "Prévue, mais non financée", score: 1 },
          { value: "c", label: "Aucune clause", score: 0 },
          { value: "nc", label: "Non concerné (pas d'associé)", score: null }, // exclus du calcul
        ]},
    ]},
    { code: "sect3", titre: "Section 3 — Transmission & fiscalité", questions: [
      { id: "d3q1", texte: "Avez-vous une idée claire de qui reprendrait l'entreprise (enfant, associé, cadre, cession externe) ?",
        ...g3("Oui, un successeur est identifié et informé", "Une piste, non confirmée", "Aucune idée pour l'instant") },
      { id: "d3q2", texte: "Un plan de transmission (calendrier, mode : donation, cession, holding) a-t-il été engagé avec un professionnel ?",
        ...g3("Oui, en cours avec un conseil", "Y avoir pensé, rien de formel", "Non") },
      { id: "d3q3", texte: "Connaissez-vous les dispositifs fiscaux de transmission d'entreprise (Pacte Dutreil, donation-partage, holding) et leur impact sur votre situation ?",
        ...g3("Oui, j'ai déjà été conseillé sur le sujet", "J'en ai entendu parler, sans plus", "Non") },
    ]},
    { code: "sect4", titre: "Section 4 — Protection de la famille", questions: [
      { id: "d4q1", texte: "En cas de décès, votre conjoint(e) ou vos héritiers seraient-ils protégés financièrement pendant la transition de l'entreprise ?",
        ...g3("Oui, une assurance homme-clé ou un dispositif est en place", "Partiellement", "Non, ou je ne sais pas") },
      { id: "d4q2", texte: "Avez-vous distingué votre patrimoine professionnel de votre patrimoine personnel pour protéger votre famille des risques de l'entreprise ?",
        ...g3("Oui, clairement structuré", "Partiellement", "Non") },
    ]},
    { code: "sect5", titre: "Section 5 — Anticipation & documents", questions: [
      { id: "d5q1", texte: "Avez-vous rédigé un testament ou des directives précisant vos volontés concernant l'entreprise ?",
        ...g3("Oui", "En cours de rédaction", "Non") },
      { id: "d5q2", texte: "Vos proches et associés savent-ils où trouver les documents essentiels (statuts, contrats, assurances, contacts des conseils) en cas de coup dur ?",
        ...g3("Oui, tout est centralisé et accessible", "Partiellement", "Non") },
      { id: "d5q3", texte: "À quand remonte la dernière fois que vous avez pris le temps, avec un professionnel, de réfléchir sérieusement à l'avenir de votre entreprise sans vous ?",
        ...g3("Moins d'un an", "Plus de deux ans", "Jamais vraiment") },
    ]},
  ],
  societe: {
    titre: "Informations société",
    champs: [
      { id: "raison_sociale", label: "Raison sociale", type: "text", required: true },
      { id: "secteur", label: "Secteur d'activité", type: "select", required: true, options: [
        "Industrie / production","Commerce / distribution","Services B2B","Services B2C","BTP",
        "Santé / médico-social","Restauration / hôtellerie","Technologie / logiciel",
        "Finance / conseil","Agriculture / viticulture","Immobilier","Autre"
      ]},
    ],
  },
  complementaires: {
    titre: "Questions complémentaires — visibles uniquement par vous",
    questions: [
      { id: "dsize",    texte: "Effectif", type: "select", options: ["Aucun salarié","1 à 9 salariés","10 salariés et plus"] },
      { id: "dassoc",   texte: "Structure associative", type: "select", options: ["Dirigeant seul","Plusieurs associés"] },
      { id: "dcession", texte: "Cession ou transmission envisagée", type: "select", options: ["Dans moins de 2 ans","Dans 2 à 5 ans","Pas prévue"] },
    ],
  },
};

// ═══════════════ C) OUVRIR UNE SUCCESSION ═════════════════════════════════════
export const QUESTIONNAIRE_OUVRIR = {
  code: "ouvrir_succession",
  sections: [
    { code: "defunt", titre: "Le défunt et le décès", champs: [
      { id: "def_prenom", label: "Prénom du défunt", type: "text", required: true },
      { id: "def_nom",    label: "Nom du défunt", type: "text", required: true },
      { id: "def_territoire", label: "Territoire de résidence principale", type: "select", required: true,
        options: ["Hexagone","Guadeloupe","Martinique","Guyane","La Réunion","Mayotte","Saint-Martin","Saint-Barthélemy","Nouvelle-Calédonie","Polynésie","Étranger"] },
      { id: "def_ville",  label: "Ville ou code postal", type: "text", required: true },
      { id: "def_date",   label: "Date du décès", type: "date", required: true },
      { id: "def_testament", label: "Un testament est-il connu ?", type: "select", options: ["Oui","Non","Je ne sais pas"] },
      { id: "def_enfants", label: "Le défunt avait-il des enfants ?", type: "select", options: ["Oui","Non","Je ne sais pas"] },
      { id: "def_notaire", label: "Un notaire a-t-il déjà été désigné ?", type: "select", options: ["Oui","Non","Je ne sais pas"] },
      { id: "def_dirigeant", label: "Le défunt était-il chef d'entreprise ou associé ?", type: "select", options: ["Oui","Non"] },
    ]},
    { code: "heritiers", titre: "Les héritiers", champs: [
      { id: "h_nombre", label: "Nombre d'héritiers potentiels", type: "number", required: true },
      { id: "h_identifies", label: "Tous identifiés et joignables ?", type: "select", options: ["Oui","Non"] },
      { id: "h_diaspora", label: "Héritiers hors du territoire (diaspora) ?", type: "select", options: ["Oui","Non"] },
      { id: "h_introuvables", label: "Héritiers introuvables ou d'identité incertaine ?", type: "select", options: ["Oui","Non","Je ne sais pas"] },
    ]},
    { code: "patrimoine", titre: "Le patrimoine", champs: [
      { id: "p_immo", label: "Un bien immobilier fait-il partie de la succession ?", type: "select", options: ["Oui","Non"] },
      { id: "p_uniquement", label: "Patrimoine uniquement immobilier et foncier ?", type: "select", options: ["Oui","Non","Je ne sais pas"] },
    ]},
    { code: "climat", titre: "Climat familial", champs: [
      { id: "c_desaccords", label: "Désaccords entre héritiers sur le partage ?", type: "select", options: ["Oui","Non"] },
    ]},
  ],
  arbre_genealogique: {
    titre: "Arbre généalogique",
    aide: "Ajoutez chaque personne concernée par la succession.",
    schema: [
      { id: "prenom", label: "Prénom", type: "text" },
      { id: "nom", label: "Nom", type: "text" },
      { id: "lien", label: "Lien avec le défunt", type: "select", options: ["Conjoint(e)","Enfant","Petit-enfant","Père/Mère","Frère/Sœur","Neveu/Nièce","Cousin(e)","Autre"] },
      { id: "vivant", label: "Statut", type: "select", options: ["Vivant","Décédé"] },
      { id: "residence", label: "Ville / pays de résidence", type: "text" },
    ],
  },
  documents: {
    titre: "Documents",
    options: ["En ma possession","À obtenir","Je ne sais pas"],
    items: [
      { id: "doc_acte_deces", label: "Acte de décès" },
      { id: "doc_livret", label: "Livret de famille / actes de naissance" },
      { id: "doc_pieces", label: "Pièces d'identité des héritiers" },
      { id: "doc_mariage", label: "Contrat de mariage / PACS" },
      { id: "doc_titre", label: "Titre(s) de propriété" },
      { id: "doc_banque", label: "Relevés bancaires et contrats d'assurance-vie" },
      { id: "doc_domicile", label: "Justificatifs de domicile des héritiers hors territoire" },
    ],
  },
};

// ═══════════════ D) FONCIER CLAIR ════════════════════════════════════════════
const ONS = { type: "select", options: ["Oui","Non","Je ne sais pas"] };
export const QUESTIONNAIRE_FONCIER = {
  code: "foncier_clair",
  sections: [
    { code: "bien", titre: "Le bien", champs: [
      { id: "bien_territoire", label: "Territoire", type: "select", required: true,
        options: ["Guadeloupe","Martinique","Guyane","La Réunion","Mayotte","Saint-Martin","Saint-Barthélemy","Autre outre-mer","Hexagone"] },
      { id: "bien_type", label: "Type", type: "select", required: true, options: ["Terrain nu","Maison ou bâti","Autre ou je ne sais pas"] },
      { id: "bien_succession", label: "Bien issu d'une succession non réglée ou d'une indivision ?", ...ONS, required: true },
    ]},
    { code: "possession", titre: "Possession", champs: [
      { id: "poss_annee", label: "Année de début d'occupation continue (1900 → aujourd'hui)", type: "annee", required: true, min: 1900 },
      { id: "f1", label: "Occupez-vous ce bien de façon ininterrompue depuis cette date (sans abandon) ? (art. 2258)", ...ONS, required: true },
      { id: "f2", label: "Votre possession est-elle paisible (sans violence ni contrainte) ? (art. 2261)", ...ONS, required: true },
      { id: "f3", label: "Votre possession est-elle publique et visible (non cachée) ? (art. 2261)", ...ONS, required: true },
      { id: "f4", label: "Vous comportez-vous en propriétaire (entretien, travaux, paiement de la taxe foncière) ? (art. 2255)", ...ONS, required: true },
      { id: "f5", label: "Votre possession a-t-elle déjà été contestée par un tiers (héritier, voisin, ancien propriétaire) ?", ...ONS, required: true },
    ]},
    { code: "titre", titre: "Titre & preuves", champs: [
      { id: "f6", label: "Disposez-vous d'un acte de propriété, même imparfait (« juste titre ») ? (art. 2272 al. 2)", ...ONS, required: true },
      { id: "f7", label: "Pensiez-vous cet acte pleinement valable au moment de l'obtenir (« bonne foi ») ?", ...ONS, required: true },
    ]},
  ],
  documents_multi: {
    titre: "Documents disponibles",
    id: "docs_dispo",
    options: [
      "Factures / quittances à mon nom et à l'adresse du bien",
      "Avis de taxe foncière payés à mon nom",
      "Photos datées",
      "Témoignages écrits",
      "Constat de commissaire de justice",
      "Justificatif de domicile officiel",
      "Acte ou titre même imparfait",
      "Aucun",
    ],
  },
};

// ═══════════════ Helpers ═════════════════════════════════════════════════════
export function getQuestionnaire(code) {
  return {
    bilan_succession:  QUESTIONNAIRE_SUCCESSION,
    bilan_dirigeants:  QUESTIONNAIRE_DIRIGEANTS,
    ouvrir_succession: QUESTIONNAIRE_OUVRIR,
    foncier_clair:     QUESTIONNAIRE_FONCIER,
  }[code];
}

// Calcule l'ensemble des IDs de questions/champs obligatoires + le nombre déjà renseignés
export function computeProgress(qDef, parcours) {
  const rep = parcours?.reponses || {};
  const spec = parcours?.donnees_specifiques || {};
  let total = 0, done = 0;
  const isFilled = (v) => v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && v.length === 0);

  // Questions Oui/Partiel/Non ou graduées (obligatoires)
  (qDef.sections || []).forEach(sec => {
    (sec.questions || []).forEach(q => { total++; if (isFilled(rep[q.id])) done++; });
    (sec.champs || []).forEach(c => {
      if (c.required) {
        total++;
        const v = (spec[sec.code]?.[c.id] ?? rep[c.id]);
        if (isFilled(v)) done++;
      }
    });
  });

  // Champs société (dirigeants)
  if (qDef.societe) qDef.societe.champs.forEach(c => {
    if (c.required) {
      total++;
      if (isFilled(spec.societe?.[c.id])) done++;
    }
  });

  return { total, done, remaining: total - done, pct: total ? Math.round(done * 100 / total) : 0 };
}
